"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pandeAuthorizeActions = require("../authorize/pandeAuthorizeActions");
var _pandeMailTemplateActions = require("../mailtemplate/pandeMailTemplateActions");
var _pandeReportActions = require("../report/pandeReportActions");
var _pandeSearchActions = require("../search/pandeSearchActions");
var _pandeTotalizeActions = require("../totalize/pandeTotalizeActions");
var _pandeConditionActions = require("./pandeConditionActions");
const pandeReducers = {
  pandeSearch: _pandeSearchActions.pandeSearchReducer,
  pandeTotalize: _pandeTotalizeActions.pandeTotalizeReducer,
  pandeShareCondition: _pandeConditionActions.pandeConditionReducer,
  pandeReport: _pandeReportActions.pandeReportReducer,
  pandeMailTemplate: _pandeMailTemplateActions.pandeMailTemplateReducer,
  pandeAuthorize: _pandeAuthorizeActions.pandeAuthorizeReducer
};
var _default = exports.default = pandeReducers;